export const STATIC_PAGE_PATH_PREFIX = '/static';
